export default {
    computed: {
        drawer: {
            get() {
                return this.$store.state.ui.drawer;
            },
            set(value) {
                this.$store.commit('ui/drawer', { value });
            }
        }
    }
}